jQuery(function ($) {

    // Enable Magnific Popup for gallery
    $('.gallery').each(function() {
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            gallery: {
                enabled: true,
                tCounter: '%curr% / %total%' 
            },
            image: {
                titleSrc: 'title' 
                // this tells the script which attribute has your caption
            }            
        });
    });
    
});
